"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledLine = exports.StyledLineItem = void 0;
var styled_components_1 = __importStar(require("styled-components"));
var lineSize = '0.4rem';
var slide = (0, styled_components_1.keyframes)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  from {\n    bottom: 0;\n  }\n"], ["\n  from {\n    bottom: 0;\n  }\n"])));
exports.StyledLineItem = styled_components_1.default.div(function (_a) {
    var mediaQueries = _a.theme.mediaQueries, barWidth = _a.barWidth;
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    flex: 1;\n    margin: 0.3rem 0; // Matches bar gap for focus rings.\n    flex-direction: row;\n    position: relative;\n\n    ", " {\n      margin: 0 0.3rem; // Matches bar gap for focus rings.\n      flex-direction: column-reverse;\n      height: 100%;\n      max-width: ", ";\n    }\n  "], ["\n    flex: 1;\n    margin: 0.3rem 0; // Matches bar gap for focus rings.\n    flex-direction: row;\n    position: relative;\n\n    ", " {\n      margin: 0 0.3rem; // Matches bar gap for focus rings.\n      flex-direction: column-reverse;\n      height: 100%;\n      max-width: ", ";\n    }\n  "])), mediaQueries.smallAndUp, barWidth);
});
exports.StyledLine = styled_components_1.default.div.attrs(function (_a) {
    var size = _a.size, color = _a.color;
    return ({
        style: {
            bottom: size,
            left: size,
            backgroundColor: color,
        },
    });
})(function (_a) {
    var mediaQueries = _a.theme.mediaQueries;
    return (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n    width: ", ";\n    top: 0;\n    margin-left: -", ";\n\n    ", " {\n      height: ", ";\n      width: 100%;\n      left: 50% !important;\n      top: auto !important;\n      margin-left: 0;\n      transform: translateX(-50%);\n      margin-bottom: -", ";\n      animation: ", " 0.5s ease-out forwards;\n\n      @media (prefers-reduced-motion) {\n        .animation {\n          animation: none;\n        }\n      }\n    }\n  "], ["\n    position: absolute;\n    z-index: 1;\n    height: 100%;\n    width: ", ";\n    top: 0;\n    margin-left: -", ";\n\n    ", " {\n      height: ", ";\n      width: 100%;\n      left: 50% !important;\n      top: auto !important;\n      margin-left: 0;\n      transform: translateX(-50%);\n      margin-bottom: -", ";\n      animation: ", " 0.5s ease-out forwards;\n\n      @media (prefers-reduced-motion) {\n        .animation {\n          animation: none;\n        }\n      }\n    }\n  "])), lineSize, lineSize, mediaQueries.smallAndUp, lineSize, lineSize, slide);
});
var templateObject_1, templateObject_2, templateObject_3;
